import { RootState } from 'models/store';

// ==============================|| MEMBER ACCOUNT SELECTORS ||============================== //

export const selectEmsMemberAccountList = (state: RootState) =>
  state.eai.emsMemberAccount.emsMemberAccountList;

export const selectEmsMemberAccountListNotForLogin = (state: RootState) =>
  state.eai.emsMemberAccount.emsMemberAccountListNotForLogin;

export const selectEmsMemberAccountDetail = (state: RootState) =>
  state.eai.emsMemberAccount.emsMemberAccountDetail;
